module.exports = __webpack_public_path__ + "img/lightgreen-ribbon.0707d17a.svg";